import React from 'react';
import { IAriServiceModelAssemblySearch } from '../../../actions/DataServiceEntities.g';

interface IAssemblyDropdownComponent {
    baseClassName: string;
    assemblyData: IAriServiceModelAssemblySearch[];
    onAssemblySelect(id: number): void;
    defaultOptionString: string;
}

export const AssemblyDropdownComponent: React.FC<IAssemblyDropdownComponent> = ({
    baseClassName,
    assemblyData,
    onAssemblySelect,
    defaultOptionString
}) => {
    const handleAssemblySelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const id = e.target.value;
        onAssemblySelect(parseInt(id, 10));
    };
    if (!assemblyData) {
        return null;
    }

    return (
        <div className={`${baseClassName}__dropdown`}>
            <select className={`${baseClassName}__dropdown-select`} onChange={handleAssemblySelect}>
                <option value={'0'}>{defaultOptionString}</option>
                {assemblyData.map(assembly => (
                    <option key={assembly.Id} value={assembly.Id}>
                        {assembly.Name}
                    </option>
                ))}
            </select>
        </div>
    );
};
